import * as styles from './styles.css';
import { clsx } from 'clsx';
import advertImage from './assets/advert-img.png';
import advertImageCollapsed from './assets/advert-img-collapsed.png';
import firstLittleImage from './assets/first-little-img.png';
import secondLittleImage from './assets/second-little-img.png';
import thirdLittleImage from './assets/third-little-img.png';
import { LazyImage } from 'shared/components/LazyImage';
import { TDeviceType } from '@cian/ui-kit';

const THUMBNAIL_IMAGES = [firstLittleImage, secondLittleImage, thirdLittleImage];

interface IAdvertBlockProps {
  device: TDeviceType;
  isExpanded: boolean;
}

export const AdvertBlock: React.FC<IAdvertBlockProps> = ({ isExpanded, device }) => (
  <div className={clsx(styles['container'], styles[device])}>
    <div className={clsx(styles['wrapper'], isExpanded && styles['wrapper-expanded'])}>
      <div className={styles['images-column']}>
        <LazyImage
          src={isExpanded ? advertImageCollapsed : advertImage}
          alt=""
          wrapperClassName={clsx(styles['image'])}
        />
        <div className={styles['thumbnails']}>
          {isExpanded &&
            THUMBNAIL_IMAGES.map((src, index) => (
              <LazyImage key={index} src={src} alt="" wrapperClassName={styles['thumbnail']} />
            ))}
        </div>
      </div>
      <div className={styles['text-block']}>
        <div className={styles['text']}>
          {isExpanded && <div className={styles['promo-label']}>Выгодное предложение</div>}
          <div className={styles['title']}>3-комн. аппарт., 148,6 м², 38/39</div>
        </div>
        <div className={styles['prices']}>
          <div className={styles['full-price']}>13 250 000 ₽</div>
          <div className={styles['price-per-square']}>118 331 ₽/м2</div>
        </div>
      </div>
    </div>
  </div>
);
